export default "__VITE_ASSET__CBW9r_rO__"